import { jsxs as c, Fragment as d, jsx as s } from "react/jsx-runtime";
import { IconButton as m, Menu as f, MenuItem as p } from "@material-ui/core";
import { createContext as g, useState as v } from "react";
import { MoreHoriz as x } from "@material-ui/icons";
import b from "jwt-decode";
import { useAuth as y } from "react-oauth2-pkce";
import "@funcional/react-ui";
var A = Object.defineProperty, P = (t, e, o) => e in t ? A(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, n = (t, e, o) => (P(t, typeof e != "symbol" ? e + "" : e, o), o);
class S {
  constructor(e) {
    n(this, "ssoProfiles", {}), n(this, "expiresAt"), n(this, "name"), n(this, "email"), this.ssoProfiles = (e == null ? void 0 : e.profiles) || {}, this.expiresAt = e.exp, this.name = (e == null ? void 0 : e.name) || (e == null ? void 0 : e.email) || (e == null ? void 0 : e.sub), this.email = (e == null ? void 0 : e.email) || (e == null ? void 0 : e.name) || (e == null ? void 0 : e.sub);
  }
  expired() {
    return (/* @__PURE__ */ new Date()).getTime() > this.expiresAt * 1e3;
  }
  hasSsoRole(e) {
    return !!this.ssoProfiles[e];
  }
  hasSsoProfile(e, o) {
    return this.getSsoRoleIdentities(e).includes(o);
  }
  getSsoRoles() {
    return Object.keys(this.ssoProfiles);
  }
  getSsoRoleIdentities(e) {
    return this.ssoProfiles[e] || [];
  }
  hasAnyOfTheseSsoRoles(...e) {
    if (!e || e.length === 0)
      throw Error("No roles informed");
    return this.getSsoRoles().filter((o) => e.includes(o)).length > 0;
  }
  hasAllOfTheseSsoRoles(...e) {
    if (!e || e.length === 0)
      throw Error("No roles informed");
    return this.getSsoRoles().filter((o) => e.includes(o)).length === e.length;
  }
}
function k(t) {
  if (t)
    try {
      const e = b(t);
      return new S(e);
    } catch (e) {
      console.error(e);
    }
}
function R() {
  var t;
  const { authService: e } = y(), o = k((t = e.getAuthTokens()) == null ? void 0 : t.access_token);
  return {
    user: o,
    login: () => e.authorize(),
    logout: () => e.logout(),
    isPending: () => e.isPending(),
    isAuthenticated: () => {
      if (e.isAuthenticated()) {
        if (o && !o.expired())
          return !0;
        e.logout();
      }
      return !1;
    }
  };
}
const C = {
  isAllowedTo: () => Promise.resolve(!1)
};
g(C);
const O = "text-gray-400 dark:hover:text-gray-300 dark:text-gray-400";
function F(t) {
  const { options: e } = t, { user: o } = R(), [i, l] = v(null);
  return /* @__PURE__ */ c(d, { children: [
    /* @__PURE__ */ s(
      m,
      {
        className: O,
        "aria-label": "more",
        "aria-controls": "long-menu",
        "aria-haspopup": "true",
        onClick: (r) => {
          l(r.currentTarget);
        },
        children: /* @__PURE__ */ s(x, {})
      }
    ),
    /* @__PURE__ */ s(
      f,
      {
        id: "long-menu",
        anchorEl: i,
        keepMounted: !0,
        open: !!i,
        onClose: () => {
          l(null);
        },
        MenuListProps: { "aria-labelledby": "basic-button" },
        children: e.map(({ label: r, show: a, roles: u }, h) => {
          if (a && (o != null && o.hasAnyOfTheseSsoRoles(...u)))
            return /* @__PURE__ */ s(p, { selected: r === "Pyxis", children: r }, h);
        })
      }
    )
  ] });
}
export {
  F as O,
  R as c
};
